module.exports = __webpack_public_path__ + "media/images/category_icons/bars-c18999d7ffcda8018f9b593b5f2b8741.svg";